import React from 'react';
import { CTAButton } from '../CTAButton';
export function DeliverySection() {
  return <div className="space-y-6" data-id="element-43">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-44">
        The "Direct-Access" Promise: Does It Really Deliver?
      </h2>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-45">
        The company claims this device can replace expensive dermatologist
        treatments.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-46">
        Bold claim. But after using it for three months, I can confidently say:
        Yes, it delivers.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-47">
        Here's what sets it apart:
      </p>
      <h3 className="text-xl font-bold text-gray-900 pt-4" data-id="element-48">
        It doesn't just cover up aging signs—it addresses them at the source.
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-49">
        The hollow microneedles create pathways for ingredients to reach living
        skin cells. The clinical-grade serums actually rebuild collagen and
        elasticity at the dermal layer where aging happens.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-50">
        It's not magic. It's science that was previously only available in
        medical settings.
      </p>
      <h3 className="text-xl font-bold text-gray-900 pt-4" data-id="element-51">
        The results build over time.
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-52">
        Each monthly treatment compounds the previous results. My skin continues
        to improve with each use.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-53">
        At three months, my skin looks better than it has in a decade.
      </p>
      <h3 className="text-xl font-bold text-gray-900 pt-4" data-id="element-54">
        It fits into my actual life.
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-55">I don't have to:</p>
      <ul className="list-disc list-inside space-y-2 pl-4" data-id="element-56">
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-57">
          Schedule appointments months in advance
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-58">
          Take time off work for recovery
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-59">
          Pay hundreds of dollars per session
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-60">
          Deal with redness or downtime
        </li>
      </ul>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-61">
        Five minutes at home. Once a month. That's genuinely achievable.
      </p>
      <div className="py-4" data-id="element-62">
        <CTAButton data-id="element-63">TRY THIS DEVICE NOW →</CTAButton>
      </div>
    </div>;
}